module.exports = function() {
  $(document).ready(function(){
    // au clic sur le bouton loupe de la recherche
    $('.search-form input[type="submit"]').click((e) => {
      e.preventDefault();
      const searchValue = $('.search-form input[type="search"]').val();

      // lancement de l'ajax
      $.ajax({
        url: ajaxurl,
        type: "POST",
        crossDomain: true,
        data: {
          'action': 'search_action',
          'search': searchValue
        }
      }).done((response) => {
        $('.search-box__result').html(response); // Afficher le HTML
        $('.search-box__wrapper').addClass('js-is-open'); // Ouverture du résultat
      });
    });

    // au clic sur le bouton close de la recherche
    $('.search-box .search-box__close').on('click', () => {
      $('.search-box__result').html(''); // clear search result
      $('.search-form__label input[type="search"]').val(''); // clear input search
    });
  });

  // const min_characters = 3;
  // $('.search-form input[type="search"]').on('input propertychange', (e) => {
  //   const searchValue = $('.search-form input[type="search"]').val();    

  //   if (searchValue !== '' && searchValue.length > min_characters) {
  //     // lancement de l'ajax
  //     $.ajax({
  //       url: ajaxurl,
  //       type: "POST",
  //       crossDomain: true,
  //       data: {
  //         'action': 'search_action',
  //         'search': searchValue
  //       }
  //     }).done((response) => {
  //       $('.search-box__result').html(response); // Afficher le HTML
  //       $('.search-box__wrapper').addClass('js-is-open'); // Ouverture du résultat
  //     });
  //   }
    
  // })
}
